import { render } from "./FransysSignature.vue?vue&type=template&id=0819092e&scoped=true&ts=true"
import script from "./FransysSignature.vue?vue&type=script&lang=ts"
export * from "./FransysSignature.vue?vue&type=script&lang=ts"

import "./FransysSignature.vue?vue&type=style&index=0&id=0819092e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0819092e"]])

export default __exports__